module.exports = __webpack_public_path__ + "img/4_17.0016ab9c.png";